import { render } from "./OTPmodal.vue?vue&type=template&id=284e78a2&scoped=true"
import script from "./OTPmodal.vue?vue&type=script&lang=js"
export * from "./OTPmodal.vue?vue&type=script&lang=js"

import "./OTPmodal.vue?vue&type=style&index=0&id=284e78a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284e78a2"]])

export default __exports__